import { defaultLocale, type Locale } from './config';
import { enDictionary } from './dictionaries/en';
import { ruDictionary } from './dictionaries/ru';
import { ukDictionary } from './dictionaries/uk';
import type { PlatformDictionary } from './types';

const dictionaries: Record<Locale, PlatformDictionary> = {
  en: enDictionary,
  uk: ukDictionary,
  ru: ruDictionary,
};

export function getTranslations(locale: Locale): PlatformDictionary {
  return dictionaries[locale] ?? dictionaries[defaultLocale];
}

export function interpolateTemplate(template: string, values: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    return values[key] ?? match;
  });
}
